import { render } from "./WishlistToggle.vue?vue&type=template&id=761a7ad2"
import script from "./WishlistToggle.vue?vue&type=script&lang=js"
export * from "./WishlistToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__